import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac/permissions'
import { Templates } from '@/features/templates'

const searchSchema = z.object({
  page: z.number().int().positive().optional().catch(1),
  pageSize: z.number().int().positive().optional().catch(10),
  name: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
  category: z
    .array(
      z.enum([
        'REACTION',
        'COMPARISON',
        'OPINION',
        'RELATABLE',
        'CHALLENGE',
        'SITUATION',
        'OTHER',
      ])
    )
    .optional()
    .catch([]),
  status: z
    .array(z.enum(['DRAFT', 'ACTIVE', 'INACTIVE', 'ARCHIVED']))
    .optional()
    .catch([]),
  sortBy: z.string().optional().catch('createdAt'),
  sortOrder: z.enum(['asc', 'desc']).optional().catch('desc'),
})

export const Route = createFileRoute('/_authenticated/templates/')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (!auth.canAccess([PERMISSIONS.MEMES.READ])) {
      throw redirect({
        to: '/403',
      })
    }
  },
  component: Templates,
})
